<div *ngIf="transitionForm" class="form-modal">
  <h1 mat-dialog-title>{{'TRANSITION' | translate}}</h1>
  <div mat-dialog-content>
    <form [formGroup]="transitionForm" class="form-horizontal">
      <div class="form-group">

        <!-- Panel base -->
        <div class="col-md-4">
          <div class="panel panel-default">
            <div class="panel-body no-horizontal-padding">
              <div class="form-group">
                <!-- Do Estado -->
                <div class="col-md-12 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-select placeholder="{{'FROM_STATE'|translate}}" formControlName="FromStateID"
                      [ngClass]="{ 'mat-input-invalid': formErrors.FromStateID }">
                      <!--<mat-option value=''></mat-option>-->
                      <mat-option *ngFor="let state of statesList" [value]="state.ID">{{state.Name}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-error *ngIf="formErrors.FromStateID" class="font75per" [translate]
                    [translateParams]="formErrorsParam.FromStateID">{{
                  formErrors.FromStateID }}</mat-error>
                </div>
                <div class="col-md-12 col-xs-12 spacer-bottom-xs"></div>
                <!-- Para Estado -->
                <div class="col-md-12 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-select placeholder="{{'TO_STATE'|translate}}" formControlName="ToStateID"
                      [ngClass]="{ 'mat-input-invalid': formErrors.ToStateID }">
                      <!--<mat-option value=''></mat-option>-->
                      <mat-option *ngFor="let state of statesList" [value]="state.ID">{{state.Name}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-error *ngIf="formErrors.ToStateID" class="font75per" [translate]
                    [translateParams]="formErrorsParam.ToStateID">{{ formErrors.ToStateID }}</mat-error>
                </div>
                <div class="col-md-12 col-xs-12 spacer-bottom-xs"></div>
                <!-- Ação -->
                <div class="col-md-12 col-sm-12">
                  <mat-form-field class="allwidth">
                    <input matInput placeholder="{{ 'ACTION_NAME' | translate}}" formControlName="ActionVerb">
                  </mat-form-field>
                  <mat-error *ngIf="formErrors.ActionVerb" class="font75per">{{formErrors.ActionVerb}}</mat-error>
                </div>
                <div class="col-md-12 col-xs-12 spacer-bottom-xs"></div>
                <!-- Checkbox tem limite -->
                <div class="col-md-12 col-sm-12" style="padding-top:5px">
                  <mat-checkbox class="allwidth" formControlName="HasLimit">{{ 'LIMIT_VALUE' | translate}}
                  </mat-checkbox>
                </div>
                <!-- Limite mínimo -->
                <div class="col-md-12 col-sm-12 no-padding-right">
                  <mat-form-field class="allwidth" [ngClass]="{ 'mat-input-invalid': formErrors.MinimumLimit }">
                    <input matInput placeholder="Desde (€)" formControlName="MinimumLimit">
                  </mat-form-field>
                  <mat-error *ngIf="formErrors.MinimumLimit" class="font75per" [translate]
                    [translateParams]="formErrorsParam.MinimumLimit">{{ formErrors.MinimumLimit }}</mat-error>
                </div>
                <div class="col-md-12 col-xs-12 spacer-bottom-xs"></div>
                <!-- Limite máximo -->
                <div class="col-md-12 col-sm-12 no-padding-right">
                  <mat-form-field class="allwidth" [ngClass]="{ 'mat-input-invalid': formErrors.MaximumLimit }">
                    <input matInput placeholder="Até (€)" formControlName="MaximumLimit">
                  </mat-form-field>
                  <mat-error *ngIf="formErrors.MaximumLimit" class="font75per" [translate]
                    [translateParams]="formErrorsParam.MaximumLimit">{{
                    formErrors.MaximumLimit }}</mat-error>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--Paineis de criação e aprovação lado a lado-->
        <div class="col-sm-8">
          <div class="row">
            <!-- Painel de criação-->
            <div class="col-sm-6">
              <div class="col-sm-12">
                <h5>
                  <strong>{{'CREATION'|translate}}</strong>
                </h5>
              </div>
              <!-- Panel da Tabela de Roles criação -->
              <div class="col-sm-12">
                <div class="panel panel-default">
                  <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPnPopup11"
                    (click)="collPnPopup11 = !collPnPopup11">
                    <h5 class="panel-title">
                      <i class="fas fa-users"></i>
                      <strong>{{'PROFILES'|translate}}</strong>
                      <i class="collapse-icon fas"
                        [ngClass]="{'fa-caret-down': collPnPopup11, 'fa-caret-up': !collPnPopup11}"></i>
                    </h5>
                  </div>
                  <div id="collPnPopup11" class="panel-body no-horizontal-padding collapse in">
                    <table id="tabelaWorkflowUsersRoles" class="table table-bordered display" cellspacing="0">
                      <thead>
                        <tr>
                          <th>
                            <strong>{{ 'NAME'| translate}}</strong>
                          </th>
                          <th></th>
                        </tr>
                        <tr>
                          <th>
                            <mat-form-field class="full-width findInputContainer">
                              <input type="text" matInput placeholder="{{'FILTER'|translate}}" class="findInput">
                            </mat-form-field>
                          </th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody></tbody>
                    </table>
                  </div>
                </div>
              </div>
              <!-- Panel da Tabela de Utilizadores criação -->
              <div class="col-sm-12">
                <div class="panel panel-default">
                  <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPnPopup1"
                    (click)="collPnPopup1 = !collPnPopup1">
                    <h5 class="panel-title">
                      <i class="fas fa-user"></i>
                      <strong>{{'USERS'|translate}}</strong>
                      <i class="collapse-icon fas"
                        [ngClass]="{'fa-caret-down': collPnPopup1, 'fa-caret-up': !collPnPopup1}"></i>
                    </h5>
                  </div>
                  <div id="collPnPopup1" class="panel-body no-horizontal-padding collapse in">
                    <table id="tabelaWorkflowUsers" class="table table-bordered display" cellspacing="0">
                      <thead>
                        <tr>
                          <th>
                            <strong>{{ 'NAME'| translate}}</strong>
                          </th>
                          <th></th>
                        </tr>
                        <tr>
                          <th>
                            <mat-form-field class="full-width findInputContainer">
                              <input type="text" matInput placeholder="{{'FILTER'|translate}}" class="findInput">
                            </mat-form-field>
                          </th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody></tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <!-- Fim Painel de criação-->
            <!--Painel de aprovação-->
            <div class="col-sm-6">
              <div class="col-sm-12">
                <h5>
                  <strong>{{'APPROVATION'|translate}}</strong>
                </h5>
              </div>
              <!-- Panel da Tabela de roles de Aprovadores -->
              <div class="col-sm-12">
                <div class="panel panel-default">
                  <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPnPopup12"
                    (click)="collPnPopup12 = !collPnPopup12">
                    <h5 class="panel-title">
                      <i class="fas fa-users"></i>
                      <strong>{{'PROFILES'|translate}}</strong>
                      <i class="collapse-icon fas"
                        [ngClass]="{'fa-caret-down': collPnPopup12, 'fa-caret-up': !collPnPopup12}"></i>
                    </h5>
                  </div>
                  <div id="collPnPopup12" class="panel-body no-horizontal-padding collapse in">
                    <table id="tabelaWorkflowApproversRoles" class="table table-bordered display" cellspacing="0">
                      <thead>
                        <tr>
                          <th>
                            <strong>{{ 'NAME'| translate}}</strong>
                          </th>
                          <th></th>
                        </tr>
                        <tr>
                          <th>
                            <mat-form-field class="full-width findInputContainer">
                              <input type="text" matInput placeholder="{{'FILTER'|translate}}" class="findInput">
                            </mat-form-field>
                          </th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody></tbody>
                    </table>
                  </div>
                </div>
              </div>
              <!-- Panel da Tabela de utilizadores Aprovadores -->
              <div class="col-sm-12">
                <div class="panel panel-default">
                  <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPnPopup2"
                    (click)="collPnPopup2 = !collPnPopup2">
                    <h5 class="panel-title">
                      <i class="fas fa-user"></i>
                      <strong>{{'USERS'|translate}}</strong>
                      <i class="collapse-icon fas"
                        [ngClass]="{'fa-caret-down': collPnPopup2, 'fa-caret-up': !collPnPopup2}"></i>
                    </h5>
                  </div>
                  <div id="collPnPopup2" class="panel-body no-horizontal-padding collapse in">
                    <table id="tabelaWorkflowApprovers" class="table table-bordered display" cellspacing="0">
                      <thead>
                        <tr>
                          <th>
                            <strong>{{ 'NAME'| translate}}</strong>
                          </th>
                          <th></th>
                        </tr>
                        <tr>
                          <th>
                            <mat-form-field class="full-width findInputContainer">
                              <input type="text" matInput placeholder="{{'FILTER'|translate}}" class="findInput">
                            </mat-form-field>
                          </th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody></tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <!-- Fim Painel de aprovação-->
          </div>
        </div>
        <!--Fim paineis lado a lado criação e aprovação -->
      </div>
    </form>
  </div>
  <div mat-dialog-actions>
    <div class="full-width text-right">
      <button type="button" class="btn btn-default" (click)="resetForm();dialogRef.close(null)">
        <i class="fas fa-ban"></i>&nbsp;{{'BUTTON.CANCEL' | translate}}
      </button>
      <button type="button" class="btn btn-primary" (click)="save()" [disabled]="!transitionForm.valid">
        <i class="far fa-save"></i>&nbsp;{{'BUTTON.SAVE' | translate}}
      </button>
    </div>
  </div>
</div>